import { render, staticRenderFns } from "./AlteracoesAssociacoesDistrito.vue?vue&type=template&id=2f9c22a2"
import script from "./AlteracoesAssociacoesDistrito.vue?vue&type=script&lang=ts"
export * from "./AlteracoesAssociacoesDistrito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports